/*
 * @Description: 
 * @Author: yingbin
 * @Date: 2019-08-23 15:57:00
 * @LastEditTime: 2019-09-03 11:15:45
 * @LastEditors: yingbin
 */
import utils from '@/utils/utils';
const state={
    userInfo: utils.getCookie("USER_INFO") || '',
    createInfo: JSON.parse(sessionStorage.getItem('createInfo')) || {},
    isAuth: sessionStorage.getItem('isAuth')||false,
    help_menu_path:'',
    address:""
}
export default state